<template>
  <td class="content" :colspan="headers.length">
    <v-row class="mt-3 mb-3">
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.squareMetersPrice') }}
        </h6>
        <span class="caption" v-if="item.square_meter_price">
          {{ formatMoney(item.square_meter_price) }}
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.baseSquareMetersPrice') }}
        </h6>
        <span class="caption" v-if="item.base_square_meters_size">
          {{ item.base_square_meters_size }}m²
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.displacementTax') }}
        </h6>
        <span class="caption" v-if="item.displacement_tax">
          {{ item.displacement_tax }}%
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.taxSquareMeters') }}
        </h6>
        <span class="caption" v-if="item.square_meter_tax">
          {{ item.square_meter_tax }}%
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.furnitureTax') }}
        </h6>
        <span class="caption" v-if="item.furniture_tax">
          {{ item.furniture_tax }}%
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.semiFurnitureTax') }}
        </h6>
        <span class="caption" v-if="item.semi_furniture_tax">
          {{ item.semi_furniture_tax }}%
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.houseTax') }}
        </h6>
        <span class="caption" v-if="item.house_tax">
          {{ item.house_tax }}%
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.trousseauTax') }}
        </h6>
        <span class="caption" v-if="item.trousseau_tax">
          {{ item.trousseau_tax }}%
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.urgencyTax') }}
        </h6>
        <span class="caption" v-if="item.urgency_tax">
          {{ item.urgency_tax }}%
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col v-if="item.urgency_tax && item.urgency_tax > 0" cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.hostUrgencyTax') }}
        </h6>
        <span class="caption" v-if="item.host_urgency_tax">
          {{ item.host_urgency_tax }}%
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col v-if="item.urgency_tax && item.urgency_tax > 0" cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.urgencyHoursLimit') }}
        </h6>
        <span class="caption" v-if="item.urgency_hours_limit">
          {{ item.urgency_hours_limit }}h
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
    </v-row>
  </td>
</template>

<script>
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'TableServiceContractDetails',

  props: {
    headers: {
      type: Array,
      required: true,
    },

    item: {
      type: Object,
      required: true,
    },
  },

  methods: {
    formatMoney(amount) {
      return catalogMonetary(amount)
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  padding: 30px;
  background-color: #fff;
}
</style>
